var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 945,
    height: 946,
    viewBox: "0 0 945 946",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M689.275 932.988L438.48 682.236L316.914 803.802C306.42 814.296 291.184 818.62 276.658 815.262C262.135 811.82 250.463 801.157 245.763 787.012L2.59065 57.5319C-2.57323 42.0833 1.45589 25.0413 12.9586 13.5386C24.4183 2.07892 41.5032 -2.11923 56.9519 3.17074L786.432 246.343C800.58 251.046 811.24 262.715 814.682 277.238C818.083 291.721 813.759 306.957 803.222 317.494L681.656 439.06L932.408 689.853C949.198 706.642 949.198 733.846 932.408 750.636L750.058 932.985C733.266 949.781 706.065 949.781 689.275 932.988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.c0391f14bc8c3b128edd13fb635b0c0d.svg";
export { ForwardRef as ReactComponent };